var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('div',{staticClass:"home-logo"},[_c('img',{attrs:{"src":"/logo.png","alt":"LOGO"}})])])}]

export { render, staticRenderFns }